import { X } from 'lucide-react';
import { useI18n } from '../../contexts/I18nContext';
import { ThemeToggle } from '../theme/ThemeToggle';
import { useSidebar } from './SidebarContext';

/**
 * Theme switch plus, on mobile, the drawer's close button — the top-right
 * corner of all three sidebar variants (main, chat history, team chat).
 *
 * Two details are deliberate and easy to undo by accident:
 *
 * - No `gap`. The coarse-pointer rule in index.css gives each button a 44x44
 *   hit area around a ~30px icon, so there are already ~14px of dead space
 *   between the two glyphs. Any gap on top of that reads as a gap twice the
 *   size it looks like in the markup.
 * - `-mr-1.5` pulls that same dead space back out of the header's `px-4`, so
 *   the close icon lines up optically with the content edge below it instead
 *   of floating inset — and hands the ~6px back to the brand name beside it,
 *   which is competing for the same row.
 */
export function SidebarHeaderControls() {
  const { isMobile, closeMobile } = useSidebar();
  const { t } = useI18n();

  return (
    <div className="-mr-1.5 flex shrink-0 items-center">
      <ThemeToggle />
      {isMobile && (
        <button
          type="button"
          onClick={closeMobile}
          aria-label={t('sidebar.closeMenu')}
          className="inline-flex items-center justify-center rounded-md p-1.5 text-muted-foreground hover:bg-accent hover:text-foreground"
        >
          <X size={20} />
        </button>
      )}
    </div>
  );
}
